import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from "react-router-dom"
import "./css/register.css";
import logo from "../../assets/images/meily.svg"
import { FaUser, FaLock } from "react-icons/fa";
import { useLoading } from '../../utils/loading/LoadingContext';
function Register() {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [repeatPassword, setRepeatPassword] = useState('');
    
    const [errorMessage, setErrorMessage] = useState("");
    const navigate = useNavigate();
    const { setLoading } = useLoading();


    const baseUrl = process.env.REACT_APP_DJANGO_API_BASE_URL
 
    const handleSubmit = async (event) => {
        event.preventDefault();
        setErrorMessage('')
        setLoading(true)
        try {
            if(password === repeatPassword){ 
            const response = await axios.post(`${baseUrl}/api/register`, { username, password })
            console.log(response.data);
            navigate("/Login")
        }

            else {
              setErrorMessage("Passwords are not the same!");
            }
        } catch (error) {
            const message =
              error.response && error.response.data && error.response.data.error
                ? error.response.data.error
                : "Login failed. Please try again.";
            setErrorMessage(message);
          }
          setLoading(false);
        };


    return (
        <div className="register-body">
            <div className="register-wrapper">
        <form onSubmit={handleSubmit}>
        {/* <h1>Register</h1> */}
        <div className="logo">
         <img src={logo} />
      </div>
      {errorMessage && <div className='error'>{errorMessage}</div>}
        <div className="input-box">
            <input type="text" value={username} onChange={e => setUsername(e.target.value)} placeholder="Username" required />
            <FaUser className="icon" />
            </div>
            <div className="input-box">
            <input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="Password" required />
            <FaLock className="icon"/>
            </div>
            <div className="input-box">
            <input type="password" value={repeatPassword} onChange={e => setRepeatPassword(e.target.value)} placeholder="Confirm Password" required />
            
            </div>
            <button type="submit" disabled={setLoading}>Register</button>
            <div className="register-link">
          <p>
            have an account? <a href="/login">Login</a>
          </p>
        </div>
        </form>
        </div>
        </div>
    );
}

export default Register;
